import {Board} from './board.model';

export type ItemStatus = {
    active: boolean;
    board?: Board;
    boardId: string;
    color: string;
    id: string;
    order: number;
    statusType: string;
    textColor: string;
    title: string;
};
export interface ItemStatusRequest {
    boardSlug: string;
}
export interface ItemStatusResponse {
    itemStatuses: ItemStatus[];
}

export enum BoardDefaultStatusType {
    New = 'New',
    Open = 'Open',
    Finalized = 'Finalized',
}
